import { createStyles } from '@mantine/core';

export const HEADER_SIDE_SLOT_SIZE_DESKTOP = 72;
export const HEADER_MAX_WIDTH = 1600;
export const HEADER_HEIGHT_DESKTOP = HEADER_SIDE_SLOT_SIZE_DESKTOP;

const useStyles = createStyles((theme, _, getRef) => ({
  container: {
    height: 72,
    background: theme.colors.gray[9],

    [theme.fn.smallerThan('md')]: {
      height: 48,
    },
  },
  desktop: {
    height: '100%',
    width: '100%',
    overflow: 'hidden',

    [theme.fn.smallerThan('md')]: {
      display: 'none',
    },
  },
  mobile: {
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing.xs,
    paddingRight: theme.spacing.xs,

    [theme.fn.largerThan('md')]: {
      display: 'none',
    },
  },
  content: {
    display: 'grid',
    gridTemplateColumns: '72px 1fr 72px',
    maxWidth: theme.other.layout.maxWidth + 72 * 2 - theme.other.layout.paddingLg * 2,
    margin: '0 auto',

    [theme.fn.smallerThan('md')]: {
      gridTemplateColumns: '72px 1fr 72px',
    },
  },
  closeLink: {
    width: 72,
    height: 72,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '@media (hover: hover)': {
      '& svg': {
        transition: 'stroke 0.1s ease-in-out',
      },

      '&:hover svg': {
        stroke: theme.colors.blue[3],
      },
    },

    [theme.fn.smallerThan('md')]: {
      width: 48,
      height: 48,
    },
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    minWidth: 0,
    flex: '1 1 auto',
    overflow: 'hidden',
    maxWidth: '35vw',
  },
  titleLink: {
    color: theme.white,
    textDecoration: 'none',
    maxWidth: '100%',
    display: 'block',
    overflow: 'hidden',

    '@media (hover: hover)': {
      transition: 'color 0.1s ease-in-out',
      '&:hover': {
        color: theme.colors.blue[3],

        [`& .${getRef('titleIcon')}`]: {
          stroke: theme.colors.blue[3],
        },
      },
    },
  },
  titleGroup: {
    maxWidth: '100%',
  },
  titleText: {
    maxWidth: '100%',
  },
  titleIcon: {
    ref: getRef('titleIcon'),
    transition: 'stroke 0.1s',
    stroke: theme.colors.gray[3],
    flexShrink: 0,
  },
  stats: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    flex: '0 0 auto',
    minWidth: 'fit-content',
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    gap: theme.other.spacing._16,
  },
  contestHuddleWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing.xs,
  },
  contestHuddleButton: {
    // Match stat badge styling (same bg, radius, padding)
    backgroundColor: theme.colors.gray2[5],
    borderRadius: theme.radius.sm,
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    // Match stat badge height (two lines of text + padding)
    height: 56,
    minHeight: 'unset',
    gap: theme.other.spacing._4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,

    '&:hover': {
      backgroundColor: theme.colors.gray2[5],
    },

    '& .mantine-Button-inner': {
      gap: theme.other.spacing._4,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    '& .mantine-Button-label': {
      display: 'flex',
      alignItems: 'center',
      gap: theme.other.spacing._4,
    },

    [theme.fn.smallerThan('lg')]: {
      paddingLeft: theme.spacing.sm,
      paddingRight: theme.spacing.sm,
    },
  },
  notificationPip: {
    position: 'absolute',
    top: -4,
    right: -4,
    zIndex: 1000,
  },
  orangeDot: {
    width: 13,
    height: 13,
    borderRadius: '50%',
    backgroundColor: theme.colors.orange[4],
    border: `2px solid ${theme.colors.gray[9]}`,
  },
  stat: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    paddingTop: theme.spacing.xs,
    paddingBottom: theme.spacing.xs,
    backgroundColor: theme.colors.gray2[5],
    borderRadius: theme.radius.sm,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    minWidth: 114,
    flexShrink: 0,

    '&:not(:last-child)': {
      marginRight: theme.spacing.xs,
    },

    [theme.fn.smallerThan('lg')]: {
      minWidth: 100,
      paddingLeft: theme.spacing.sm,
      paddingRight: theme.spacing.sm,
    },
  },
  mobileInfoLink: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
